import React, { useState } from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Box,
  Flex,
  Spinner,
  Text,
  Center,
  Divider
} from '@chakra-ui/react';
// Drawer/Modal Components
import ModalHeader from '../ModalComponent/ModalHeader';
import ModalLeftSection from '../ModalComponent/ModalLeftSection';
import ModalRightSection from '../ModalComponent/ModalRightSection';

const CardOffcanvas = ({ isOpen, onClose, task, loading = false, columns, setColumns, moveCardAPI }) => {
  const [activeTab, setActiveTab] = useState('description');

  if (!task && !loading) return null;

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      size="xl" // Drawer size, adjust as per your need
    >
      <DrawerOverlay bg="rgba(9, 30, 66, 0.54)" />
      <DrawerContent
        bg="white"
        borderRadius="6px 0 0 6px"
        maxW="1040px"
        maxH="100vh"
        overflow="hidden"
        display="flex"
        flexDirection="column"
      >
        {loading ? (
          <Box h="400px">
            <Center h="100%">
              <Spinner size="xl" color="blue.500" />
              <Text ml={4}>Loading task details...</Text>
            </Center>
          </Box>
        ) : task ? (
          <>
            {/* Header - Fixed at top */}
            <Box>
              <ModalHeader task={task} onClose={onClose} />
            </Box>

            {/* Drawer Body - Scrollable */}
            <DrawerBody
              p={0}
              flex="1"
              overflow="hidden"
              display="flex"
              flexDirection="column"
            >
              <Flex
                h="100%"
                overflow="hidden"
              >
                {/* Left Section */}
                <Box
                  flex="2"
                  p={6}
                  pr={4}
                  overflowY="auto"
                  maxH="100%"
                  css={{
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#c1c1c1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#a1a1a1',
                    },
                  }}
                >
                  <ModalLeftSection
                    task={task}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                  />
                </Box>

                {/* Divider */}
                <Divider orientation="vertical" />

                {/* Right Section */}
                <Box
                  flex="1"
                  p={6}
                  pl={4}
                  bg="#FAFBFC"
                  overflowY="auto"
                  maxH="100%"
                  css={{
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f1f1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#c1c1c1',
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#a1a1a1',
                    },
                  }}
                >
                  <ModalRightSection
                    task={task}
                    columns={columns}
                    setColumns={setColumns}
                    moveCardAPI={moveCardAPI}
                  />
                </Box>
              </Flex>
            </DrawerBody>
          </>
        ) : null}
      </DrawerContent>
    </Drawer>
  );
};

export default CardOffcanvas;
